import {RcFile} from 'antd/es/upload/interface'
import {FilterListBean} from 'common/api/api'
import {env} from 'common/env'
import TypeEnum = FilterListBean.TypeEnum

const basePath = env.endpoint

export class DirectApi {

    async uploadFilterListFile(
        type: TypeEnum,
        file: RcFile,
        onProgress: (progress: number) => void,
        setXHR: (xhr:XMLHttpRequest) => void
    ) {
        return new Promise((resolve, reject) => {
            const formData = new FormData();
            formData.append('file', file); // ключ должен быть "file" как в IdUploadBody

            const xhr = new XMLHttpRequest();

            xhr.open('POST', `${basePath}/api/filter-list/upload/${type}`);
            xhr.withCredentials = true;
            xhr.upload.onprogress = (event) => {
                if (event.lengthComputable) {
                    onProgress(Math.round((event.loaded * 100) / event.total));
                }
            }

            xhr.onload = () => {
                if (xhr.status >= 200 && xhr.status < 300) {
                    resolve(xhr.responseText);
                } else {
                    try {
                        reject(JSON.parse(xhr.response));
                    } catch {
                        reject(xhr.response);
                    }
                }
            };

            xhr.setRequestHeader("interface-id", env.interfaceId)

            xhr.onerror = (e) => reject(e)

            xhr.send(formData);
        });
    }
}